export function AlertDiamondIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
            <path
                stroke="#FFF9DB"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.667}
                d="M1.123 8.528a.667.667 0 0 1 0-.943l6.39-6.39c.26-.261.682-.261.943 0l6.39 6.39c.26.26.26.682 0 .943l-6.39 6.39a.667.667 0 0 1-.943 0l-6.39-6.39Z"
                clipRule="evenodd"
            />
            <path
                stroke="#FFF9DB"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={0.667}
                d="M8 9.407V4.74M7.991 10.74a.163.163 0 0 0-.158.17.17.17 0 0 0 .167.163h.006a.164.164 0 0 0 .158-.17A.169.169 0 0 0 8 10.74M8 10.74h-.006"
            />
        </svg>
    );
}
